
import EditBase from "../EditBase"

class EditStraightArrow extends EditBase{

    constructor(options) {
        super(options);
    }


    initProperty() {
        var $this = this;
        var positions=[];
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            positions=$this.plot.attrPlot["edit_positions"];
            return new $this.Cesium.PolygonHierarchy($this.drawBase.computeDrawstraightArrow(positions));
        }, false);
        this.plot.polygon.hierarchy = hierarchyProperty;
    }

}

export default EditStraightArrow;